<template>
    <div class="center-content">
        <label>Start Archive Date:</label>
        <input
            type="date"
            name="start-archive-date"
            v-model="startArchiveDate"
        />
        <label>End Archive Date:</label>
        <input
            type="date"
            name="end-archive-date"
            v-model="endArchiveDate"
        />
        <label for="limitOptions">Limit</label>
		<select  v-model="limit" id="limitOptions">
			<option v-for="(item, index) in limitOptions" :key="index" :value="item.value">{{ item.text }}</option>
		</select>
        <button class="btn" @click="applyChanges()">Apply Changes</button>
    </div>
	<div class="center-content">
		<button @click="previousPage()" class="btn">Previous</button>
		<button @click="nextPage()" class="btn">Next</button>
		<span style="align-content: center;" :currentPage="currentPage">page {{ currentPage }}</span>
	</div>
    <br>
    <div v-if="serverBusy">
		<span class="loading-icon"></span>
		<span class="loading-message">{{ busyText }}</span>
	</div>
	<table v-else class="play-archive-list">
        <tr class="sticky">
            <th>Game title</th>
            <th>Casino Id</th>
            <th>Resolved Time</th>
            <th>Total Wager</th>
            <th>Total Win</th>
        </tr>
        <tr v-for="record in playRecords" class="center-text">
            <td>{{ record.gameTitle }}</td>
            <td>{{ record.casinoId }}</td>
            <td>{{new Date(record.resolvedTime).toLocaleTimeString(this.localeString, dateOptions) }}</td>
            <th>{{ systemCurrencyTool.formatFromAU(record.totalWagerAU, systemFull) }}</th>
            <th>{{ systemCurrencyTool.formatFromAU(record.totalWinAU, systemFull) }}</th>
        </tr> 
    </table>
</template>

<script>

// Tools from awesome-phonenumber. For now were just using parsePhoneNumber
// https://www.npmjs.com/package/awesome-phonenumber
import { onBeforeUnmount } from "vue";
export default {
	name: "UserPlayArchive",
	components: {
	},
	props: {
		adminState: Object,
		casinoList: Array,
        selectedUser: Object,
		isMobile: Boolean,
		systemCurrencyTool: Object,
		systemSettings: Object,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			serverBusy: false,
			busyText: "",
			offset: 0,
			limit: this.isMobile ? 5 : 10,
			currentPage: null,
			isLastPage: false,
            playRecords:[],
            startArchiveDate: null,
            endArchiveDate: null,
			currentPage: 1,
			isLastPage: false,
		};
	},
	watch: {
		selectedUser() {
			 this.getUserPlayRecords();
		}
	},
	created() {
		let defaultEndDate = new Date();
		let endYear = defaultEndDate.getFullYear();
		let endDay = defaultEndDate.getDate().toString();
		//getMonth() returns on a scale from 0 to 11
		// so I have to add +1 to the month for it to match calendar count
		let endMonth = (defaultEndDate.getMonth()+1).toString();

		if(endDay.length == 1) endDay = 0 + endDay;
		if(endMonth.length == 1) endMonth = 0 + endMonth;
		this.endArchiveDate = endYear+"-"+endMonth+"-"+endDay;

		
		let defaultStartDate = new Date(1970, 0,1);
		let startYear = defaultStartDate.getFullYear();
		let startDay = defaultStartDate.getDate().toString();
		let startMonth = (defaultStartDate.getMonth()+1).toString();

		if(startDay.length == 1) startDay = 0 + startDay;
		if(startMonth.length == 1) startMonth = 0+ startMonth;
		this.startArchiveDate = startYear+"-"+startMonth+"-"+ startDay;

		this.eventBus.on("deselectUser", () => {
			this.offset = 0;
			this.currentPage = 1;
			this.isLastPage = false;
			this.playRecords = [];
			this.limit = 10;
		});
		onBeforeUnmount(() => {
			this.eventBus.off("deselectUser");
		});

	},

	mounted() {
		this.serverBusy = false;
        this.getUserPlayRecords();
	},
	methods: {
		applyChanges() {
			this.currentPage = 1;
			this.offset = 0;
			this.getUserPlayRecords();
		},

		async getUserPlayRecords() {
			this.serverBusy = true;
			this.busyText = "Getting user play records";

			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

            let requestUrl = new URL(`/api/v1/play/listarchived`, this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState?.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			
			let params = requestUrl.searchParams;
			params.set("offset", this.offset);
			params.set("limit", this.limit);
            params.set("userId", this.selectedUser.id);
            if(this.startArchiveDate != null && this.endArchiveDate != null) {
                
                params.set("startDate", new Date(this.startArchiveDate).toISOString());
                params.set("endDate", new Date(this.endArchiveDate).toISOString());
            }

			requestUrl.search = params.toString();
			
			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				const response = await fetch(request);
				this.playRecords = await response.json();
				this.serverBusy = false;
				this.busyText = "";
			}
			catch (e){
				this.serverBusy = false;
				this.busyText = "";
			}
		},
		previousPage() {
			if (this.currentPage == 1) return;
			this.currentPage--;
			this.offset = this.offset - this.limit;
			this.getUserPlayRecords();
		},
		nextPage() {
			if (this.isLastPage || this.playRecords.length < this.limit) return;
			this.offset = this.offset + this.limit;
			this.currentPage++;
			this.getUserPlayRecords();
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.play-archive-list {
	width: 100%;
	text-align: left;
	border-collapse: collapse;
}

.play-archive-list th,
.play-archive-list td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.play-archive-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}

.center-content {
    display: flex;
    justify-content: center;
}

.center-text {
    text-align: center;
}

</style>
